export const LSC_LOGO_PATH =
  '/assets/stream-center/stream_center_logo_purple_transparent.png';
export const LSC_PRODUCT_NAME = 'League Stream Center';
export const LSC_BYLINE = 'by Scoutlytics';

export const GAME_KEY_OPTIONS = [
  { value: 'custom', label: 'Custom / other' },
  { value: 'madden', label: 'Madden' },
  { value: 'cfb', label: 'College football' },
  { value: 'nba2k', label: 'NBA 2K' },
  { value: 'eafc', label: 'EA FC' },
  { value: 'cod', label: 'Call of Duty' },
  { value: 'rocket_league', label: 'Rocket League' },
] as const;

export const COMMISSIONER_ROLES = new Set(['commissioner', 'admin']);

export const REASON_CODE_LABELS: Record<string, string> = {
  BROADCASTER_MEMBER_MATCH: 'Stream account matched member',
  MATCH_WINDOW_MATCH: 'Within match time window',
  SCHEDULED_AT_NEAR: 'Near scheduled time',
  IDENTITY_SIDE_MATCH: 'Identity matches side',
  SIDE_LABEL_MATCH: 'Side label matched',
  TITLE_LEAGUE_TAG: 'Title mentions league tag',
  TITLE_STAGE_LABEL: 'Title mentions stage',
  TITLE_SIDE_LABEL: 'Title mentions side',
  TITLE_OPPONENT_SIDE: 'Title mentions opponent side',
  DURATION_REASONABLE: 'Reasonable duration',
  ACTIVE_MATCH: 'Active competition match',
  REJECT_NOT_LEAGUE_MEMBER: 'Broadcaster is not a league member',
  REJECT_CANDIDATE_STATUS: 'This VOD is not available to review',
  REJECT_NO_ACTIVE_MATCHES: 'No active league games to match',
  REJECT_OUTSIDE_WINDOW: 'Outside the game time window',
  REJECT_IDENTITY_CONFLICT: 'Identity conflict with the assigned sides',
};

export const COMMISSIONER_VOD_MESSAGE =
  'Only league commissioners can sync and review VOD candidates right now.';

export const COMMISSIONER_ONLY_NOTICE =
  'Commissioner tools are only available to league commissioners. Ask a commissioner if you need setup or activation help.';

export const REVIEW_STATUS_LABELS: Record<string, string> = {
  pending_review: 'Pending review',
  approved: 'Approved',
  rejected: 'Rejected',
  dismissed: 'Dismissed',
  published: 'Published',
  unpublished: 'Unpublished',
};

export const ARCHIVE_STATUS_LABELS: Record<string, string> = {
  published: 'Published',
  unpublished: 'Unpublished',
  removed: 'Removed',
};

export { isLscFallbackPath as isLscPath } from './routing';

export function slugifyLeagueName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 48);
}
